import React from "react";

export function Logo({ className = "", size = 48, inverted = false }) {
  const src = inverted ? "/brand/cadditive-logo-light.png" : "/brand/cadditive-logo.png";
  return (
    <div className={`flex items-center ${className}`} data-testid="cadditive-logo">
      <img
        src={src}
        alt="cadditive"
        style={{ height: size, width: "auto", display: "block" }}
        className="select-none"
        draggable={false}
      />
    </div>
  );
}

export function LogoMark({ size = 48, inverted = false }) {
  return <Logo size={size} inverted={inverted} />;
}
